'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Node = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dekuRedux = require('@viskan/deku-redux');

var _actions = require('./actions');

var _lib = require('./lib');

var _node = require('./components/node');

var _node2 = _interopRequireDefault(_node);

var _components = require('./components');

var _components2 = _interopRequireDefault(_components);

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Node = exports.Node = (0, _dekuRedux.connect)(function (_ref) {
	var router = _ref.router;
	return {
		path: router.pathname
	};
})(_node2.default);

var component = (0, _dekuRedux.connect)(function (_ref2, _ref3) {
	var article = _ref2.article,
	    cmsComponents = _ref2.cmsComponents,
	    router = _ref2.router,
	    tree = _ref2.tree;
	var id = _ref3.id;
	return {
		openNodes: cmsComponents.subMenu.open[id],
		path: (0, _lib.getPath)(article.article, cmsComponents.breadcrumbs, router.pathname),
		tree: tree.data
	};
}, function (dispatch, _ref4) {
	var id = _ref4.id;
	return {
		getOpenNodes: function getOpenNodes(tree, activePath, componentId) {
			return dispatch((0, _actions.getOpenNodes)({ tree: tree, activePath: activePath, componentId: componentId }));
		},
		toggle: function toggle(payload) {
			return dispatch((0, _actions.toggle)(_extends({}, payload, { componentId: id })));
		}
	};
})(_components2.default);

exports.default = { component: component, config: _config2.default };